import { listAllAlarmsByHabitatQuery } from '@akin-home/alarms/frontend';
import { listAllAlertsByHabitatQuery } from '@akin-home/alerts/frontend';
import {
  CalendarItemType,
  MealType,
  ModelMealFilterInput,
} from '@akin-home/amplify';
import { notNullOrUndefined } from '@akin-home/arrays';
import { sortByStartDate } from '@akin-home/dates';
import { listAllEventsByHabitatQuery } from '@akin-home/events/frontend';
import { listAllMealsByHabitatQuery } from '@akin-home/meals/frontend';
import { formatCalendarItemToModel } from '../functions';

interface Query {
  habitatID: string;
  filter: {
    from: string;
    to: string;

    title?: string;
    mealType?: MealType;
  };
}

interface Params {
  types?: CalendarItemType[];

  query: Query;
}

export const listCalendarItemsByHabitat = async (params: Params) => {
  const {
    query: { habitatID },
  } = params;

  const { mealType, ...filter } = params.query.filter;

  const types = params.types || [
    CalendarItemType.Event,
    CalendarItemType.Alert,
    CalendarItemType.Alarm,
    CalendarItemType.Meal,
  ];

  const queries = types
    .map((type) => {
      if (type === CalendarItemType.Event) {
        return listAllEventsByHabitatQuery(habitatID, filter);
      }

      if (type === CalendarItemType.Alert) {
        return listAllAlertsByHabitatQuery(habitatID, filter);
      }

      if (type === CalendarItemType.Alarm) {
        return listAllAlarmsByHabitatQuery(habitatID, filter);
      }

      if (type === CalendarItemType.Meal) {
        let meal_type_filter: ModelMealFilterInput | undefined;

        if (mealType) {
          meal_type_filter = { mealType: { eq: mealType } };
        }

        return listAllMealsByHabitatQuery({
          habitatID,
          start: { between: [filter.from, filter.to] },
          filter: meal_type_filter,
        });
      }

      return;
    })
    .filter(notNullOrUndefined);

  const items = (await Promise.all(queries))
    .flat()
    .map(formatCalendarItemToModel);

  items.sort(sortByStartDate);

  return items;
};
